//react-components
import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import moment from "moment";
import { withRouter } from "react-router";
import _ from "lodash";

//Custom UI Components
import Pagination from "../CustomUIComponents/Pagination/Pagination";

//constants
import { LOAN_INFO, BASIC_INFO, BRANCH_INFO, APPRESTA_BRANCH_INFO } from "./Constants";
import {
  DEFAULT_PAGINATION_ACTIVE_PAGE,
  DEFAULT_PAGINATION_RECORDS_COUNT,
} from "../CustomUIComponents/Pagination/PaginationConstants";
import { DATE_FORMAT } from "../Utils/Constants";
import { RECEIPT_TYPES } from "../LoanApplicationList/Constants";

//Utilities
import Utility from "../Utils/Utility";
import { checkIfNumberOrDot } from "../Utils/Validations";

//styles
import "./LoanDetails.scss";

//Strings
import { Strings } from "../Translations/i18n";
import CustomModal from "../CustomUIComponents/CustomModal/CustomModal";

class LoanDetails extends React.Component {
  constructor(props) {
    super(props);
    this._amortizationTableColumns = [
      "index",
      "dueDate",
      "amountToPay",
      "amountPaid",
      "pds",
      "status",
      "receipts",
    ];

    this._toBeCollectedAmountSplitup = ["c", "i", "lf", "ttl"];
    this._collectedAmountSplitup = ["dt", "c", "i", "lf", "ttl", "pm"];

    this._summaryTableColumns = ["ndt", "atc", "uc", "ui", "ulf"];

    this.state = {
      recordsPerPage: DEFAULT_PAGINATION_RECORDS_COUNT,
      activePage: DEFAULT_PAGINATION_ACTIVE_PAGE,
      openConfirmationModal: false,
      openLateFeeModal: false,
      selectPaymentStatus: "paid",
      selectRadioButton: true,
      amountCollected: "",
      amount: "",
      paymentMethod: "select",
      paymentDenied: "",
      errorUploadDocuments: "",
      document: {},
      error: "",
      clearAll: false,
      transactionId: "",
      documents: "",
      amountSplitup: false,
      amountSplitUpData: [],
      file: null,
    };
  }

  componentDidMount() {
    this.props.getAmortizationTable({
      limit: this.state.recordsPerPage,
      offset: this.state.activePage,
    });
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.amountSplitUpData, this.props.amountSplitUpData)) {
      this.setState({
        amountSplitUpData: this.props.amountSplitUpData,
      });
    }
  }

  getLoanDetailsObject = () => {
      return {
      loanInfo: {
        amountApproved:
          this.props.loanApplicationListReducer.loanApplicationDetails
            .loanProcess.amount,
        approvedTerm:
          this.props.loanApplicationListReducer.loanApplicationDetails
            .loanProcess.terms,
        emi: this.props.loanApplicationListReducer.loanApplicationDetails
          .loanProcess.emi,
        interest:
          this.props.loanApplicationListReducer.loanApplicationDetails
            .loanProcess.rate,
        disbursementDate:
          this.props.loanApplicationListReducer.loanApplicationDetails
            .loanProcess.disbursementTime,

        category:
          this.props.loanApplicationListReducer.loanApplicationDetails
            .loanProcess.category,

        arrearsInDays:
          this.props.loanApplicationListReducer.loanApplicationDetails
            .loanProcess.arrearsInDays,

        arrearsInDaysOld:
          this.props.loanApplicationListReducer.loanApplicationDetails
            .loanProcess.arrearsInDaysOld,

        balanceToDate:
          this.props.loanApplicationListReducer.loanApplicationDetails
            .loanProcess.balanceToDate,
      },
    };
  };

  onPageChange = ({ page, pageLength }) => {
    this.setState(
      {
        activePage: page,
        recordsPerPage: pageLength,
      },
      () =>
        this.props.getAmortizationTable({
          limit: this.state.recordsPerPage,
          offset: this.state.activePage,
        })
    );
  };

  renderReceipts = (row, key, type) => {
    return row[key] && row[key].length > 0
      ? row[key].map((receipt) => {
        return (
          <span
            key={receipt}
            title={receipt}
            className="url cursorPointer"
            onClick={() => {
              this.props.downloadPaymentReceipt(receipt, type);
            }}
          >
            {` ${receipt}`}
          </span>
        );
      })
      : Strings("NA");
  };

  amountPopup = () => {
    let tableColumns = this.state.collectedAmount
      ? this._collectedAmountSplitup
      : this._toBeCollectedAmountSplitup;
    return (
      <CustomModal
        // Change visibility of modal based on props.
        open={this.state.amountSplitup}
        closeModal={this.closeModal}
        //Modal opens with specified messages in props
        modalCloseOnEsc={this.props.modalCloseOnEsc}
        className="customModal"
        headerTextId={Strings("amountSplitup")}
        center
      >
        {this.state.amountSplitUpData.length > 0 ? (
          <>
            <Row className={"amortizationHeader"}>
              {tableColumns.map((column) => {
                return (
                  <Col
                    key={column.name}
                    className="text-center"
                    md={!this.state.collectedAmount ? 3 : 2}
                  >
                    {Strings(column)}
                  </Col>
                );
              })}
            </Row>

            {this.state.amountSplitUpData.map((row) => {
              return (
                <Row className={"amortizationRows"}>
                  {tableColumns.map((column) => {
                    return (
                      <Col
                        className="text-center"
                        md={!this.state.collectedAmount ? 3 : 2}
                      >
                        {column === "dt"
                          ? moment(row[column]).format(DATE_FORMAT)
                          : column === "pm"
                          ? row[column] &&
                            row[column].map((pm, index) => {
                              return pm ? (
                                <div>
                                  {index + 1}. {Strings(pm)}
                                </div>
                              ) : null;
                            })
                          : Utility.getCurrencyRepresentationOfAmount(
                              row[column]
                            )}
                      </Col>
                    );
                  })}
                </Row>
              );
            })}
          </>
        ) : (
          <div className="noRecordsFound text-center">
            {Strings("noRecordsFound")}
          </div>
        )}
        <Row className="modalButton">
          <Button variant=""
            className="buttonBorder  mx-1"
            onClick={() => this.setState({ amountSplitup: false })}
          >
            {Strings("cancel")}
          </Button>
        </Row>
      </CustomModal>
    );
  };

  getAmortizationTableValues = (row, column) => {
    if (column === "index") {
      return row["restructuredIndex"] ? (
        <i className="fa fa-flag addOrUpdateBranchIcon"> {row[column]}</i>
      ) : (
        row[column]
      );
    } else if (column === "dueDate") {
      return moment(row[column]).format(DATE_FORMAT);
    } else if (column === "amountToPay" || column === "amountPaid") {
      return (
        <span
          key={row[column]}
          title={Utility.getCurrencyRepresentationOfAmount(row[column])}
          className="url cursorPointer"
          onClick={() => {
            this.setState(
              {
                amountSplitup: true,
                collectedAmount: column === "amountToPay" ? false : true,
              },
              () => {
                this.props.getEmiAmountSplitup({
                  ix: row["index"],
                  ic: column === "amountToPay" ? false : true,
                  lid: this.props.loanApplicationListReducer.applicationId,
                  dd: moment(row["dueDate"]).valueOf(),
                });
              }
            );
          }}
        >
          {Utility.getCurrencyRepresentationOfAmount(row[column])}
        </span>
      );
    } else if (column === "status") {
      if (row[column] === "DUE") {
        return "Debido";
      } else if (row[column] === "PAST_DUE") {
        return "Pasado Debido";
      } else if (row[column] === "PAID") {
        return "Pagado";
      } else if (row[column] === "PARTIALY_PAID") {
        return "Pago Parcial";
      }
    } else if (column === "receipts") {
      return this.renderReceipts(row, column, RECEIPT_TYPES.collection);
    } else {
      return row[column] ? row[column] : Strings("NA");
    }
  };

  getSummaryTableData = (row, column) => {
    let value;
    if (column === "ndt") {
      value = row[column]
        ? moment(row[column]).format(DATE_FORMAT)
        : Strings("NA");
    } else if (
      column === "atc" ||
      column === "uc" ||
      column === "ui" ||
      column === "ulf"
    ) {
      value = Utility.getCurrencyRepresentationOfAmount(row[column]);
    }
    return value;
  };

  renderSummaryTable = () => {
    return (
      <Row className="paddingTop">
        <Row className="mainHeaderApplication">{Strings("summaryTable")}</Row>
        {this.props.summaryData.length !== 0 ? (
          <>
            <Row className={"amortizationHeader"}>
              {this._summaryTableColumns.map((column) => {
                return (
                  <Col
                    className=" text-center"
                    md={column === "ndt" || column === "ulf" ? 3 : 2}
                  >
                    {Strings(column)}
                  </Col>
                );
              })}
            </Row>
            {this.props.summaryData.map((row) => {
              return (
                <Row className={"amortizationRows"}>
                  {this._summaryTableColumns.map((column) => {
                    return (
                      <Col
                        className="applicantName text-center"
                        md={column === "ndt" || column === "ulf" ? 3 : 2}
                      >
                        {this.getSummaryTableData(row, column)}
                      </Col>
                    );
                  })}
                </Row>
              );
            })}
          </>
        ) : (
          <div className="noRecordsFound text-center">
            {Strings("noRecordsFound")}
          </div>
        )}
      </Row>
    );
  };

  renderAmortizationTable = () => {
    return (
      <Row className="paddingTop">
        <Row className="mainHeaderApplication">
          {Strings("amortizationTable")}
        </Row>
        {this.props.amortizationData.length !== 0 ? (
          <>
            <Row className={"amortizationHeader"}>
              {this._amortizationTableColumns.map((column) => {
                return (
                  <Col
                    className="text-center"
                    md={column === "index" || column === "receipts" ? 1 : 2}
                  >
                    {Strings(column)}
                  </Col>
                );
              })}
            </Row>
            {this.props.amortizationData.map((row) => {
              return (
                <Row className={"amortizationRows"}>
                  {this._amortizationTableColumns.map((column) => {
                    return (
                      <Col
                        className="text-center"
                        md={column === "index" || column === "receipts" ? 1 : 2}
                        title={this.getAmortizationTableValues(row, column)}
                      >
                        {this.getAmortizationTableValues(row, column)}
                      </Col>
                    );
                  })}
                </Row>
              );
            })}
            <Pagination
              activePage={this.state.activePage}
              recordsPerPage={this.state.recordsPerPage}
              numberOfPages={this.props.numberOfPages}
              onPageChange={this.onPageChange}
              dropup={true}
            />
          </>
        ) : (
          <div className="noRecordsFound text-center">
            {Strings("noRecordsFound")}
          </div>
        )}
      </Row>
    );
  };

  getBasicInfoValues = (basicInfo) => {
    let clientInfo =
      this.props.loanApplicationListReducer.loanApplicationDetails.clientInfo
        .clientInfo;
    let value;
    if (basicInfo.key === "fullName") {
      value = `${clientInfo["firstName"]} ${clientInfo["lastName1"]} ${clientInfo["lastName2"]}`;
    } else if (
      basicInfo.key === "dateOfBirth" ||
      basicInfo.key === "documentExpirationDate"
    ) {
      value = moment(clientInfo[basicInfo.key]).format(DATE_FORMAT);
    // note - hide holdco Id for Apprestaq
    // } else if (basicInfo.key === "customerUniqueId") {
    //     value = clientInfo[basicInfo.key] > 0 ? clientInfo[basicInfo.key] : Strings("NA");
    } else {
      value = clientInfo[basicInfo.key]
        ? clientInfo[basicInfo.key]
        : Strings("NA");
    }
    return value;
  };

  getBranchInfoValues = () => {
    return this.props.loanApplicationListReducer?.loanApplicationDetails?.loanOrigin === "APPRESTA"
      ? (
        APPRESTA_BRANCH_INFO.map((branchInfo) => {
            return <Col md={4} key={branchInfo.key}>
                {`${
                    Strings(branchInfo.key)
                }: ${
                    this.props?.loanApplicationListReducer?.loanApplicationDetails?.associations
                    ? (this.props?.loanApplicationListReducer?.loanApplicationDetails?.associations[
                        branchInfo?.key
                    ] ?? Strings("NA")) : Strings("NA")
              }`}</Col>}
          )) : (
          BRANCH_INFO.map((branchInfo) => {
            return <Col md={4} key={branchInfo.key}>{`${
                Strings(branchInfo.key)
            }: ${
                this.props?.loanApplicationListReducer?.loanApplicationDetails?.branchInfo ?
                (this.props?.loanApplicationListReducer?.loanApplicationDetails?.branchInfo[
                    branchInfo?.key
                ] ?? Strings("NA")): Strings("NA")
            }`}</Col>}
      ))
    }

  getLoanInfoValues = (loanInfo) => {
    let loanInformation = this.getLoanDetailsObject();
    let value;
    if (loanInfo.key === "disbursementDate") {
      value = moment(loanInformation.loanInfo[loanInfo.key]).format(
        DATE_FORMAT
      );
    } else if (
      loanInfo.key === "amountApproved" ||
      loanInfo.key === "amountRequested" ||
      loanInfo.key === "emi"
    ) {
      value =
        "€ " +
        Utility.getCurrencyRepresentationOfAmount(
          loanInformation.loanInfo[loanInfo.key]
        );
    } else if (
      loanInfo.key === "arrearsInDays" ||
      loanInfo.key === "arrearsInDaysOld"
    ) {
      value = loanInformation.loanInfo[loanInfo.key]
        ? loanInformation.loanInfo[loanInfo.key]
        : 0;
    } else if (loanInfo.key === "interest") {
      return loanInformation.loanInfo[loanInfo.key];
    } else if (loanInfo.key === "balanceToDate") {
      value = loanInformation.loanInfo[loanInfo.key]
        ? "€ " +
        Utility.getCurrencyRepresentationOfAmount(
          loanInformation.loanInfo[loanInfo.key]
        )
        : 0;
    } else {
      value = loanInformation.loanInfo[loanInfo.key]
        ? loanInformation.loanInfo[loanInfo.key]
        : Strings("NA");
    }
    return value;
  };

  onClickBack = () => {
    this.props.history.goBack();
  };

  scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  validateNumberField = (event) => {
    if (!checkIfNumberOrDot(event) || event.shiftKey) {
      event.preventDefault();
    }
  };

  render() {
    return (
      <>
        <Row>
          {this.state.amountSplitup &&
            !this.props.showLoadingModal &&
            this.amountPopup()}
        </Row>
        <Row className="formLayout">
          <Row className="">
            <div className="mainHeaderApplication d-flex justify-content-between">
              <div>
                {Strings("loanInformation")} -
                {this.props.loanApplicationListReducer.applicationId}
              </div>
              <div>
                <Button variant=""
                  className="buttonBackground pull-right mx-1"
                  onClick={this.props.redirectToAdminAudit}
                >
                  {Strings("LOAN_AUDIT")}
                </Button>
              </div>
            </div>
            {LOAN_INFO.map((loanInfo) => {
              return (
                <Col md={4}>
                  {Strings(loanInfo.name)}
                  {` : ${Strings(this.getLoanInfoValues(loanInfo))}`}
                </Col>
              );
            })}
          </Row>
          <Row className="paddingTop">
            <Row className="mainHeaderApplication">
              {Strings("basicInformation")}
            </Row>
            {this.props.loanApplicationListReducer.loanApplicationDetails
              .clientInfo &&
              BASIC_INFO.map((basicInfo) => {
                return !(
                    basicInfo.key === "customerUniqueId" &&
                    this.props.loanApplicationListReducer?.loanApplicationDetails?.loanOrigin === "APPRESTA"
                ) ? (
                    <Col md={4} key={basicInfo.key}>
                        {Strings(basicInfo.name)}
                        {` : ${this.getBasicInfoValues(basicInfo)}`}
                    </Col>
                    ): (null)
                })
              }
          </Row>

          <Row className="paddingTop">
            <Row className="mainHeaderApplication">
              {Strings("branchInformation")}
            </Row>
            {this.getBranchInfoValues()}
          </Row>
        </Row>

        {this.renderSummaryTable()}
        {this.renderAmortizationTable()}

        <div className=" pull-left inputFields">
          <Button variant="" className="buttonBorder mx-1" onClick={this.onClickBack}>
            {Strings("back")}
          </Button>
        </div>
      </>
    );
  }
}

export default withRouter(LoanDetails);
